import React, { useEffect, useState } from "react";
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  TableContainer,
  TableFooter,
  CircularProgress,
  Typography,
  Paper,
  Stack,
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import clsx from "clsx";
import useStyles from "./styles";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";

const SurveyResultTable = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const tableId = `CeroTable-${props.tableId || "table-id"}`;
  const [checkedRows, setCheckedRows] = useState([]);

  const handleSortDataAscending = () => {
    props.setSortDataDescending(false);
    props.setSortDataAscending((state) => !state);
  };

  const handleSortDataDescending = () => {
    props.setSortDataAscending(false);
    props.setSortDataDescending((state) => !state);
  };

  useEffect(() => {
    props.onCheckedRowsChange(checkedRows);
  }, [checkedRows, props.onCheckedRowsChange]);

  const getHeaders = () => [
    ...props.columns.map((column, index) => {
      const isNumberColumn =
        props.data &&
        props?.data?.some((row) => typeof row[column.columnKey] === "number");

      return (
        <TableCell
          align={isNumberColumn ? "center" : "left"}
          style={{
            width: "auto",
            minWidth: "50px",
            maxWidth: "190px",
            whiteSpace: "normal",
            wordWrap: "break-word",
          }}
          className={clsx(classes.headerCell, column.classes?.header)}
          key={column.columnId || index}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {column.columnHeader.split(/(\(.*?\))/).map((text, index) => (
              <div
                key={index}
                style={{
                  textAlign:
                    isNumberColumn || column.columnKey === "status"
                      ? "center"
                      : "left",
                }}
              >
                {text}
              </div>
            ))}
            {column.columnKey === "industry_name" && props.showSort && (
              <Stack
                direction="column"
                spacing={-2}
                alignItems="center"
                borderColor={"black"}
              >
                <ExpandLessIcon
                  style={{ color: props.sortDataAscending && "blue" }}
                  onClick={handleSortDataAscending}
                />
                <ExpandMoreIcon
                  style={{ color: props.sortDataDescending && "blue" }}
                  onClick={handleSortDataDescending}
                />
              </Stack>
            )}
          </div>
        </TableCell>
      );
    }),
  ];

  const getTableRows = () =>
    props?.data?.map((rowData, rowIndex) => {
      return (
        <TableRow
          key={rowData.id}
          className={clsx(
            classes.tableDataRow,
            props.classes?.tableDataRow,
            classes.checkboxSelected,
            props.isSelectable && classes.selectableTableRow
          )}
          onClick={(event) => {
            if (!event.defaultPrevented) {
              props?.onSelectRow
                ? props.onSelectRow(rowData)
                : navigate(`/survey-result-details/${rowData._id}`);
            }
          }}
        >
          {props.columns.map((column, columnIndex) => {
            const isNumberColumn =
              typeof rowData[column.columnKey] === "number";

            return (
              <TableCell
                align={isNumberColumn ? "center" : "left"}
                style={{
                  width: "auto",
                }}
                key={`${rowData.id || rowIndex}-${
                  column.columnId || columnIndex
                }`}
                className={clsx(classes.tableBodyCell, column.classes?.column)}
              >
                {rowData[column.columnKey]}
              </TableCell>
            );
          })}
        </TableRow>
      );
    });

  const noTableRows = () => (
    <TableRow>
      <TableCell
        className={classes.noDataWarning}
        align="center"
        colSpan={props.columns.length + 1}
      >
        <Typography align="center">No data</Typography>
      </TableCell>
    </TableRow>
  );

  return (
    <InfiniteScroll
      dataLength={props?.data?.length}
      hasMore={!!props.hasMore}
      next={props.loadMore}
      scrollableTarget={tableId}
      loader={<></>}
    >
      <TableContainer
        id={tableId}
        className={clsx(classes.tableContainer, props.classes?.tableContainer)}
        component={Paper}
      >
        <Table stickyHeader id="my-table">
          <TableHead>
            <TableRow
              className={clsx(classes?.tableHeader, props.classes?.tableHeader)}
            >
              {getHeaders()}
            </TableRow>
          </TableHead>
          <TableBody className={props?.classes?.tableBody}>
            {getTableRows()}
            {!getTableRows()?.length && noTableRows()}
          </TableBody>
          {props.loading && (
            <TableFooter className={classes.tableFooter}>
              <TableRow>
                <TableCell
                  variant="footer"
                  colSpan={props.columns.length}
                  className={classes.footerCell}
                >
                  <CircularProgress
                    thickness={3}
                    size={20}
                    className={classes.progress}
                  />
                </TableCell>
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    </InfiniteScroll>
  );
};

export default SurveyResultTable;
